export function initMobileMenu(): void {
  const menuToggle = document.getElementById('menu-toggle') as HTMLButtonElement | null;
  const nav = document.querySelector('.header__nav') as HTMLElement | null;

  if (!menuToggle || !nav) return;

  // Toggle menu on button click
  menuToggle.addEventListener('click', () => {
    const isExpanded = menuToggle.getAttribute('aria-expanded') === 'true';
    const newState = !isExpanded;

    menuToggle.setAttribute('aria-expanded', String(newState));
    nav.classList.toggle('header__nav--open', newState);
    menuToggle.classList.toggle('header__menu-toggle--active', newState);
    document.body.classList.toggle('menu-open', newState);
  });

  // Close menu when clicking on a link
  const navLinks = nav.querySelectorAll('.header__nav-link');
  navLinks.forEach((link) => {
    link.addEventListener('click', () => {
      menuToggle.setAttribute('aria-expanded', 'false');
      nav.classList.remove('header__nav--open');
      menuToggle.classList.remove('header__menu-toggle--active');
      document.body.classList.remove('menu-open');
    });
  });

  // Close menu when clicking outside
  document.addEventListener('click', (e) => {
    const target = e.target as HTMLElement;
    const isExpanded = menuToggle.getAttribute('aria-expanded') === 'true';
    
    if (
      isExpanded &&
      !nav.contains(target) &&
      !menuToggle.contains(target)
    ) {
      menuToggle.setAttribute('aria-expanded', 'false');
      nav.classList.remove('header__nav--open');
      menuToggle.classList.remove('header__menu-toggle--active');
      document.body.classList.remove('menu-open');
    }
  });
}

